<template>
  <div class="box">
    <div class="mine_top" style='position:relative'>
      <div class="mine_login">
        <div
          class="mine_login_left"
        >
          <img class="mine_login_image" :src="userInfo.headimgUrl" alt="" />
          <div>
            <span class="user_name">{{ userInfo.username }} </span>
            <span class="user_id">id:{{ userInfo.uid }}</span>
          </div>
          <img class='user-card' @click="clickCard"  v-if="cardsState" src="../../static/month_card.png" alt="">
          <div v-if="isisWxAuthorized">
          <span
            style="background: #FFD9A3;
border-radius: 100px;color: #DF4B42; padding:2px 6px;font-size: 10px; margin-left: 0.3125rem"
            @click="wexinLogin(true)"
          >
            点击微信登录</span
          >
        </div>
        <div class='lucky-right'  @click="routePlay" v-if="isPlay == 0">
          <img src="../../static/zhuanpan_icon.png" alt="">
          <span>抽奖</span>
        </div>
        </div>
        <div :class="userInfo.isVip==0?'un_rember':'is_rember'" @click="routeRember">
        <div class="set-member">
          <div>
            <div>
              <img :src="userInfo.isVip==0?'../../static/unrember.png':'../../static/rember.png'" alt=""><span class="set-name">VIP会员</span>
            </div>
            <span class="set-text" v-if="userInfo.isVip == 0"
              >开通会员，畅读全站所有小说
            </span>
            <span class="set-text" v-if="userInfo.isVip == 1">
              {{ "有效期至：" + userInfo.EndTime}}
            </span>
          </div>
          <span class="set-tips"
              >{{ userInfo.isVip == 0 ? "开通" : "续费" }}
            </span>
        </div>
      </div>
      </div>
      <img class="img_bottom" :src="userInfo.isVip==0?'../../static/ss_2.png':'../../static/ss.png'" alt="">
    </div>
    <div class='content-bottom'>
      <div class="mini_login_bottom">
          <p>账户余额</p>
          <div>
            <div @click="routeCoupons">
            <span style="display: block;  font-weight: bold">{{
              userInfo.totalCouponNum
            }}</span>
            <span style="color: #888888; margin-top: 0.1875rem">优惠券</span>
          </div>
          <div @click="goCurrency">
            <span style="display: block; font-weight: bold">{{
              userInfo.number
            }}</span>
            <span style="color: #888888; margin-top: 0.1875rem">我的书币</span>
          </div>
          <span class="mine_login_right" @click="goCharge">充值</span>
          </div>
        </div>
    <div class="mine_set">
      <div class="list-set">
        <div
          class="set-item"
          v-for="(item, index) in setlist"
          :key="index"
          @click="routePage(item)"
        >
        <div>
          <img :src="'../../static/'+item.Imgurl" alt="">
          <span class="set-text">{{ item.title }}</span>
        </div>
          <div class="set-right">
            <span class="set-right-text" v-if="item.subTitle">{{
              userInfo.mobile ? userInfo.mobile : "送" + num + "书币"
            }}</span>
            <img
              class="set-right-image"
              src="../../static/forward.png"
              alt=""
            />
          </div>
        </div>
             <div
              @click="routePageOne()"
          class="set-item"
          v-if="autoSubBookSwitch==0"
        >
        <div>
          <img src="../../static/ten.png" alt="">
          <span class="set-text">订阅管理</span>
        </div>
          <div class="set-right">
            <img
              class="set-right-image"
              src="../../static/forward.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 活动轮播模块 -->
    
      <!-- 月卡显示 -->
      <div class="month_card" v-if="isShowCard">
         <div class="month_content">
          <p>今日月卡福利<span></span></p>
        <p>{{allReceiveCoins}}书币</p>
        <span @click="sendCard" v-if="receiveStatus">立即领取</span>
        <span v-else class="default">今日已领取</span>
        <p>月卡剩余<span></span></p>
        <div class="bottom-month">
            <p v-for="(item,index) in actCarAttrPartInfos" :class="actCarAttrPartInfos.length!=1&&(index+1)!=actCarAttrPartInfos.length?'dashed':''" :key="index">
              <span v-if="item.cardType==1">银卡</span>
              <span v-if="item.cardType==2">金卡</span>
              <span v-if="item.cardType==3">白金卡</span>
              <span v-if="item.cardType==4">钻石卡</span>
              <span>剩余<span>{{ item.remainDay }}</span>天</span></p>
        </div>
         </div>
         <div class="close-img" @click="closeCard">
          <img src="../../static/close-x.png" alt="" />
        </div>
      </div>
      <div v-if='emailMask' class='read_email'>
         <div>
          <span>欢迎作者投稿</span>
        <span>如果你有优秀作品请发至邮箱</span>
        <span>redubook@163.com</span>
        <span @click="copyText('redubook@163.com')">点击复制邮箱</span>
         </div>
         <div @click="emailMask=false" class="close-img" >
          <img  src="../../static/close-x.png" alt="" />
        </div>
      </div>
    </div>
    <div class='mine_acitivty'>
      <uniActivity :showSetting="3" ref="child"></uniActivity>
    </div>
    </div>

  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
import uniActivity from "../view/components/activity-swiper.vue";
export default {
  components: {
    uniActivity,
  },
  data() {
    return {
      emailMask:false,
      num: 0,
      isVip: 0,
      userInfo: {
        headimgUrl: "",
        username: "用户",
        isVip: 0,
        EndTime: "",
        uid: "",
        mobile: "",
        number: 0,
        totalCouponNum: 0,
      },
      //设置数据
      setlist: [
        {
          title: "最近阅读",
          Imgurl:'one_list.png',
          subTitle: "",
          url: "/pages/bookLastRead/index",
        },
        {
          title: "充值记录",
          Imgurl:'two_list.png',
          subTitle: "",
          url: "/pages/bookRecharge/index",
        },
        {
          title: "消费记录",
          subTitle: "",
          Imgurl:'three_list.png',
          url: "/pages/bookConsume/index",
        },
        {
          title: "绑定手机",
          subTitle: "mobile",
          Imgurl:'four_list.png',
          url: "/pages/bookPhone/index",
        },
        {
          title: "意见反馈",
          subTitle: "",
          Imgurl:'six_list.png',
          url: "/pages/bookFeedback/index",
        }
        ,
        {
          title: "作者投稿",
          subTitle: "",
          Imgurl:'nine_list.png',
          url: "",
        }
      ],
      activityList: [],
      isPlay: 1, //转盘游戏入口
      isWxAuthorized: "",
      isisWxAuthorized: false,
      isFlag: false,
      autoSubBookSwitch:1,
      queryType:2,
      isShowCard:0,
      cardsState:false,
      allReceiveCoins:0,
      actCarAttrPartInfos:[],
      receiveStatus:true
    };
  },
  mounted() {
    this.isFlag = this.$base.GetUrlParam("isFlag");
    if (this.isFlag) {
      this.wexinLogin(false);
    }
  },
  methods: {
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        console.log('内容已复制到剪贴板');
      } catch (err) {
        console.error('复制到剪贴板失败', err);
      }
    },
    clickCard(){
      this.isShowCard=1;
    },
    closeCard(){
      this.isShowCard=0;
    },
    sendCard(){
      this.queryType=1;
      this.monthCards();
    },
    monthCards() {
      //弹窗
      var params = {
        queryType: this.queryType,
      };
      this.$api
        .monthCards(params)
        .then((res) => {
          if (res.status == 1) {
       
            if(this.queryType==2){//获取书币
              this.allReceiveCoins=res.data.allReceiveCoins;
              this.cardsState=res.data.cardsState;
              this.actCarAttrPartInfos=res.data.actCarAttrPartInfos;
              this.receiveStatus=res.data.receiveStatus;
            }else{
              Toast({
                message: '领取成功',
              });
              this.getUserInfo();
              this.receiveStatus=false
            }
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
          // 失败进行的操作
        });
    },
    contentFun() {
      this.getUserInfo();
      this.bindMobileGetCurrey();
      this.insertPageAccessData();
      this.getOutReaderSwitckIsOpen();
        this.$refs.child.findRechargeActivity();
        this.queryType=2;
      this.monthCards();
    },
    wexinLogin(flag) {
      var infoCode = this.$base.GetUrlParam("code");
      if (!infoCode || flag) {
        let uri = encodeURIComponent(window.location.origin + "?isFlag=true");
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          this.$store.state.user.appid + 
          "&redirect_uri=" +
          uri +
          "&response_type=code&scope=snsapi_userinfo&state=ajjads2121sfsdf&wechat_redirect&connect_redirect=1#wechat_redirect";
      } else {
        this.snsapiRegister(infoCode);
      }
    },
    snsapiRegister(infoCode) {
      //手动授权获取isWxAuthorized
      var params = {
        code: infoCode,
      };
      this.$api.getToken(params).then((res) => {
        if (res.status == 1) {
          this.$base.setStorage("token", res.data.accessToken);
          this.$base.setStorage("openid", res.data.openid);
          this.getUserInfo();
        }
      });
    },
    getUserInfo() {
      this.$api.getUserInfo().then((res) => {
        if (res.status == 1) {
          this.$base.setStorage("nickName", res.data.nickname);
          this.$base.setStorage("headimgUrl", res.data.headImgurl);
          this.$base.setStorage("frequency", res.data.frequency);
          this.$base.setStorage("isVip", res.data.isVip);
          this.$base.setStorage("EndTime", res.data.vipEndDate);
          this.$base.setStorage("currency", res.data.currency);
          this.$base.setStorage("uid", res.data.id);
          this.$base.setStorage("mobile", res.data.mobile);
          this.$base.setStorage("isSign", res.data.isSign);
          this.$base.setStorage("isWxAuthorized", res.data.isWxAuthorized);
          this.isWxAuthorized = res.data.isWxAuthorized;
          if (this.isWxAuthorized==0) {
            this.isisWxAuthorized = true;
          } else {
            this.isisWxAuthorized = false;
          }
          this.userInfo.username = res.data.nickname;
          this.userInfo.headimgUrl = res.data.headImgurl;
          this.userInfo.uid = res.data.id;
          this.userInfo.isVip = res.data.isVip;
          this.userInfo.EndTime = res.data.vipEndDate;
          this.userInfo.number = res.data.currency;
          this.userInfo.mobile = res.data.mobile;
          this.userInfo.totalCouponNum = res.data.totalCouponNum;
          if (this.userInfo.mobile) {
            var reg = /^(\d{3})\d{4}(\d{4})$/;
            this.userInfo.mobile = this.userInfo.mobile.replace(
              reg,
              "$1****$2"
            );
          }
        }
      });
    },
    getOutReaderSwitckIsOpen() {
      this.$api.getOutReaderSwitckIsOpen().then((res) => {
        if (res.status == 1) {
          this.isPlay = res.data.isLuckdrawOpen; //抽奖入口是否开启
          this.autoSubBookSwitch=res.data.autoSubBookSwitch; 
        }
      });
    },
    insertPageAccessData() {
      var params = {
        pageName: "我的",
        pageRemark: "",
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    bindMobileGetCurrey() {
      this.$api.bindMobileGetCurrey().then((res) => {
        if (res.status == 1) {
          this.num = res.data;
        }
      });
    },
    routePage(item) {
      if(item.title=='作者投稿'){
        this.emailMask=true;
        return false;
      }
      if (item.title == "绑定手机" && this.userInfo.mobile) {
        Toast({
          message: "您已绑定手机号",
        });
        return false;
      }
      this.$router.push({
        path: item.url,
        query: {
          pageType: "bookMine",
        },
      });
    },
    routePageOne(){
       this.$router.push({
        path: "/pages/bookBuyManage/index",
        query: {
          pageType: "bookMine",
        },
      });

    },
    routePlay() {
      this.$router.push({
        path: "/pages/playGames/index",
        query: {
          pageType: "bookMine",
        },
      });
    },
    goCharge() {
      this.$router.push({
        path: "/pages/bookCharge/index",
        query: {
          pageType: "bookMine",
        },
      });
    },
    routeRember() {
      this.$router.push({
        path: "/pages/bookRember/index",
        query: {
          pageType: "bookMine",
        },
      });
    },
    routeCoupons() {
      this.$router.push({
        path: "/pages/userCoupons/index",
        query: {
          pageType: "bookMine",
        },
      });
    },
    goCurrency() {
      this.$router.push({
        path: "/pages/bookCurrency/index",
        query: {
          pageType: "bookMine",
        },
      });
    },
  },
};
</script>

<style scoped>
.img_bottom{
  width:100%;
  display:block;
  height: 13px;
    position: absolute;
    left: 0px;
    bottom: 0px;
    z-index: 99;
}
.box {
  min-height: 100%;
  background-color: #f3f3f3;
  padding-bottom:calc(60px + env(safe-area-inset-bottom));
  overflow-y: scroll;
}
.mine_top{
  height: 140px;
  overflow: hidden;
}
.mine_login {
  background-image: linear-gradient(180deg, #FF8B85 0%, #CE3A30 99%);
  box-sizing: border-box;
  padding: 20px 16px;
  position: relative;
  /* padding-bottom: 0px; */
}
.mine_login_left {
  display: flex;
  width: 100%;
  padding-bottom: 16px;
}
.mine_login_left > div {
  margin-top:-5px;
}
.user_name {
  font-size: 14px;
  color: #333333;
  height:20px;

}
.user_id {
  font-size: 12px;
color: #FFFFFF;
  height:17px;
  display: block;
}
.user-card{
  width: 51px;
height: 15px;
margin-left:6px;
margin-top:-3px;
}
.lucky-right{
  background: #FFFFFF;
border-radius: 100px 0px 0px 100px;
width:66px;
height:25px;
text-align: center;
position: absolute;
  right:0px;
  top:25px;
  display: flex;
  padding:5px 8px;
  box-sizing: border-box;
}
.lucky-right>img{
  width:14px;
  height:14px;
 margin-right:5px; 
}
.lucky-right>span{
  font-size: 12px;
color: #DE3B34;
}
.mine_login_image {
  width: 30px;
  height: 30px;
   border:1px solid #fff;
  border-radius: 50%;
  margin-right: 10px;
  margin-left: 20px;
}

.mine_login_right {
  width: 67px;
  height: 26px;
  font-size: 12px;
color: #FFFFFF;
  text-align: center;
  background: #DE3B34;
border-radius: 100px;
  line-height: 26px;
  margin-top: 12px;
}

.mini_login_bottom {
  background: #FFFFFF;
box-shadow: 0px 2px 4px 0px rgba(158,157,157,0.5);
margin:10px 0;
padding:8px 16px;
border-radius:10px;
}
.mini_login_bottom>p{
  font-size: 12px;
color: #343434;
font-weight: 600;
margin-bottom:8px;
}
.mini_login_bottom > div {
  display: flex;
  text-align: center;
  justify-content: space-between;
  padding-bottom:4px;
}
.mini_login_bottom>div>div>span:nth-of-type(1){
  font-size: 18px;
  color: #DE3B34;
}
.mini_login_bottom span {
  display: block;
  font-size: 12px;
}
.un_rember {
}
.rember_bottom{
  width:100%;
  height:10px;
  background-size: cover;
  margin:0 auto;
  background-image: url(../../static/ss.png);
}
.unrember_bottom{
  background-image: url(../../static/ss.png);
}
.is_rember{
}
.set-member {
  display: flex;
  justify-content: space-between;
  padding: 13px 16px;
  border-radius: 10px;
  box-sizing: border-box;
  border-radius: 8px 8px 0 0;
  padding-bottom:7px;
  background-size: cover;
}
.is_rember .set-member{
  background-image: url('../../static/rembertop.png');
}
.un_rember .set-member{
  background-image: url('../../static/un_rembertop.png');
}
.set-member > div {
    color: #fcca9d;
}
.set-member > div img{
width: 30px;
height:14px;
margin-right:4px;
}
.set-member > div >div>span{
  font-size: 15px;
}
.set-member > div > span {
  font-size: 12px;
  color: #fcca9d;
  line-height: 24px;
}
.un_rember .set-member > div > span{
    color:  #2D2D2D;
}
.set-name {
  font-size: 15px;
  color: #fcca9d;
  font-weight: bold;
 
 line-height: 21px;
}
.un_rember .set-name {
    color:  #2D2D2D;
}
.un_rember .set-member>.set-tips{
  background: #2D2D2D;
border-radius: 100px;
color: #FFFFFF;
}
.set-member > .set-tips {
  background-image: linear-gradient(180deg, #FFF394 0%, #FFAD46 100%);
border-radius: 100px;
  font-size: 12px;
  width: 48px;
  height: 24px;
  align-items: center;
  color: #2B2B2B;
  text-align: center;
  margin-left: 8px;
  display: block;
  line-height: 24px;
  margin-top: 9px;
}
.content-bottom{
  background-color:#f3f3f3;
  /* top: 140px;
    left: 0px;
    position: absolute; */
    /* width: 100%; */
    padding:0px 16px;
}
.mine_set {
  padding: 6px 16px;
  background-color: #ffffff;
  border-radius: 10px;
}
.mine_acitivty{
}
.list-set > .set-item {
  padding: 14.5px 0px;
  display: flex;
  justify-content: space-between;
  line-height: 20px;
  letter-spacing: 0.17px;
  font-size: 14px;
  border-bottom: 1px solid rgba(238,236,236,1);
}
.list-set > .set-item:last-of-type{
  border:none;
}
.list-set > .set-item>div:nth-of-type(1){
  display: flex;
}
.list-set > .set-item>div:nth-of-type(1)>img{
  width:20px;
  height:20px;
  margin-right:10px;
}
.list-set .set-right-image {
  width: 6px;
  height: 12px;
  margin-left: 10px;
}
.set-item {
  color: #4F4F4F;
}
.month_card{
  width: 100%;
height: 100%;
position: fixed;
left: 0px;
top: 0px;
z-index: 999;
background-color: rgba(0,0,0,.5);
}
.month_card>.month_content{
  width: 207px;
background-image: linear-gradient(180deg, #FDFAF7 0%, #FAF2EC 100%);
border-radius: 15px;
margin:0 auto;
margin-top: 149px;
padding:14px 20px;
padding-bottom: 23px;
}
.close-img{
  width: 40px;
  height: 40px;
  display: block;
  margin: 12px auto;
  text-align: center;
}
.close-img img {
  width: 24px;
  height: 24px;
  margin-top: 7px;
}
.month_content>p:nth-child(1){
  font-size: 13px;
color: #2D2D2D;
width: 80px;
height: 18px;
position: relative;
z-index:1;
font-weight: bold;
}
.month_content>p:nth-of-type(1)>span{
  position: absolute;
  bottom:0px;
  left:0px;
  width: 79px;
height: 10px;
background-image: linear-gradient(270deg, #FFF5B3 0%, #FFEA9C 100%);
z-index:-1;
}
.month_content>p:nth-of-type(2){
  font-size: 18px;
color: #DE3B34;
text-align: center;
margin: 18px auto;
font-weight: bold;

}
.month_content>span{
  width: 167px;
height: 36px;
display: block;
background-image: linear-gradient(254deg, #F69D0B 0%, #F55C0A 100%);
border-radius: 17px;
margin:0 auto;
font-size: 15px;
color: #FFFFFF;
text-align: center;
line-height: 36px;
font-weight: bold;
}
.month_content>span.default{
  background-image: linear-gradient(254deg, #BCBBB9 0%, #A29E9C 100%);
}
.month_content>p:nth-of-type(3){
  font-size: 12px;
color: #2D2D2D;
margin-top: 18px;
position: relative;
margin-bottom:12px;
z-index: 2;
font-weight: bold;
}
.month_content>p:nth-of-type(3)>span{
  position: absolute;
  bottom:0px;
  left:0px;
  width: 49px;
height: 10px;
background-image: linear-gradient(254deg, #FFE3B3 0%, #FFCD9C 100%);
z-index: -1;
}
.month_content>div{
  font-size: 12px;
color: #2D2D2D;
}
.month_content>div>p{
  display: flex;
  justify-content: space-between;
  padding:3.5px 0px;
}
.month_content>div>.dashed{
  border-bottom:2px dashed rgba(136,136,136,.5);
}
.month_content>div>p>span>span{
  color: #DE3B34;
}
.read_email{
  width: 100%;
height: 100%;
position: fixed;
left: 0px;
top: 0px;
z-index: 999;
background-color: rgba(0,0,0,.5);
}
.read_email>div:nth-of-type(1){
  width: 272px;
  height:185px;
  box-sizing: border-box;
  padding:20px 30px;
  text-align: center;
  background: #FFFFFF;
border-radius: 8px;
margin:0 auto;
margin-top: 180px;
}
.read_email>div:nth-of-type(1)>span:nth-of-type(1){
  font-size: 18px;
color: #373737;
text-align: center;
font-weight: 600;
margin-bottom:20px;
}
.read_email>div:nth-of-type(1)>span:nth-of-type(2){
  font-size: 14px;
color: #373737;
}
.read_email>div:nth-of-type(1)>span:nth-of-type(3){
  color: #1765D3;
  font-size: 14px;
}
.read_email>div:nth-of-type(1)>span:nth-of-type(4){
  background-image: linear-gradient(164deg, #FF695E 0%, #E54930 98%);
border-radius: 20px;
font-size: 14px;
color: #fff;
width:178px;
height:36px;
margin:0 auto;
line-height: 36px;
margin-top:20px;
text-align: center;

}
.read_email>div:nth-of-type(1)>span{
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/bookMine.vue